import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const StateAgencyPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Success Story - State Agency Building - Flyby Shine</title>
                        <meta name="description" content="Flyby Shine reduced a 14-day window cleaning job to just 4 hours using drone technology, preventing damage and saving taxpayer dollars." />
                        <meta name="keywords" content="Drone Cleaning, State Agency, Government Building, Window Cleaning, Damage Prevention, Time Savings, Cost Efficient, Taxpayer Savings, Drone Technology, Rapid Cleaning" />
                        <meta property="og:image" content="/assets/stateagencybuilding.jpeg" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Success Story'}
                    title={'State Agency Building – Jackson, Ms'}
                    description={`Let's explore how Flyby Shine's drone cleaning services transformed the window cleaning process for a state agency building in Jackson, Mississippi.`}
                    banner={
                        {
                            image: '/assets/stateagencybuilding.jpeg',
                            alt: 'A drone cleaning a state agency building',
                        }
                    }
                />

                <div className="success-story-article">
                    <div className="article-container">
                        <h2>
                            Success Story Breakdown
                        </h2>

                        <div className="case-study-grid">
                            {/* Problem */}
                            <div className="case-study-card" data-aos="fade-up">
                                <div className="card-header">
                                    <i className="material-icons">error_outline</i>
                                    <h3>Problem</h3>
                                </div>
                                <p>
                                    The last window cleaning took two weeks using traditional lifts. The process
                                    <strong> damaged sidewalks, landscaping, and even the building's brick exterior</strong>.
                                    Operations were disrupted and taxpayer dollars were wasted on preventable mistakes.
                                </p>
                            </div>

                            {/* Solution */}
                            <div className="case-study-card" data-aos="fade-up" data-aos-delay="100">
                                <div className="card-header">
                                    <i className="material-icons">lightbulb_outline</i>
                                    <h3>Solution</h3>
                                </div>
                                <p>
                                    Flyby Shine mobilized a <strong>two-man drone team at 4:45 a.m. on a Saturday</strong>.
                                    With zero contact on the structure and no heavy equipment, we completed the job by 9 a.m. with
                                    zero damage and zero disruption.
                                </p>
                            </div>

                            {/* Outcome */}
                            <div className="case-study-card" data-aos="fade-up" data-aos-delay="200">
                                <div className="card-header">
                                    <i className="material-icons">check_circle_outline</i>
                                    <h3>Results</h3>
                                </div>
                                <p>
                                    What once took <strong>14 days of risk and damage now takes 4 hours with precision and care</strong>.
                                    The agency saved time, avoided costly repairs, and delivered a more responsible use of taxpayer money.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{
                            image: '/assets/stateagency2.jpeg', alt: 'State agency building being cleaned by drone'
                        }}
                        title={'Dramatic Time Savings'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'time savings icon' }}
                        description={'By deploying our drone technology at 4:45 a.m. on a Saturday, we reduced the cleaning time from 14 days to just 4 hours. This precision timing allowed us to complete the entire job before regular business hours, ensuring zero disruption to state agency operations.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/stateagency3.jpeg', alt: 'Drone cleaning government building' }}
                        title={'Saving Taxpayer Dollars'}
                        heading={{ image: '/assets/flexible.svg', alt: 'taxpayer savings icon' }}
                        description={'Previous cleaning methods damaged sidewalks, landscaping, and the building\'s brick exterior. All costly repairs paid with taxpayer dollars. Our contactless drone approach eliminated these damages entirely, providing a superior clean while being responsible stewards of public resources.'}
                    />


                </ZigZag>

                <Contact />
            </PageShell>
        </>
    )
}

export default StateAgencyPage
